// https://www.customerly.io/live-chat-api/
import { UserData } from '@tm/types/common/app-api/auth'
/**
 * Types copied from react-live-chat-customerly npm package
 */
export type CustomerlyPosition = {
  bottom: number
  side: number
}

export type CustomerlyMessengerPosition = {
  mobile: CustomerlyPosition
  desktop: CustomerlyPosition
}

export type CustomerlyMessenger = {
  direction?: 'right' | 'left'
  accentColor?: string
  contrastColor?: string
  autodetectLocale?: boolean
  visible?: boolean
  visibleOnMobile?: boolean
  screenshotAvailable?: boolean
  attachmentsAvailable?: boolean
  singleConversation?: boolean
  position?: CustomerlyMessengerPosition
  disableCSSOMInjection?: boolean
}

export type CustomerlyContactProperty = {
  user_id?: string | number
  name?: string
  email?: string
  email_hash?: string // This would be best, but only for enterprise plan
  attributes?: Record<string, string>
}

export interface CustomerlyCompanyProperty {
  company?:
    | Record<string, string | number>
    | {
        company_id: string | number
        name?: string
      }
}

type CustomerlyApp = {
  app_id: string
}

export type CustomerlySettings = CustomerlyApp &
  CustomerlyMessenger &
  CustomerlyContactProperty &
  CustomerlyCompanyProperty

export interface CustomerlyWindow extends Window {
  customerly?: {
    load: (settings: CustomerlySettings) => void
    logout: () => void
  }
}

export const updateCustomerly = (userData: UserData) => {
  try {
    const { customerly } = window as unknown as CustomerlyWindow

    if (!customerly) return

    const { contact_id, email, name, role } = userData

    const {
      name: organization_name,
      id: organization_id,
      appSubscriptionInfo: { plan_id },
    } = userData.organization

    const plans = userData.organization.appSubscriptionInfo.subscription.data.plans || []
    const plan = plans.length ? plans.map(plan => plan.planId).join(', ') : plan_id

    const settings: CustomerlySettings = {
      app_id: 'c0badabb',
      user_id: contact_id,
      name: name || email,
      email,
      company: {
        company_id: organization_id,
        name: organization_name,
        plan,
        admin2_url: `https://admin2.trustmary.com/organization/${organization_id}`,
        admin_plan_url: `https://admin.trustmary.com/settings/plan?limit=1000&editId=${plan}`,
      },
      attributes: {
        role: role || '',
      },
    }

    customerly.load(settings)
  } catch (error) {
    console.log('Customerly error updateCustomerly')
    console.log(error)
  }
}

export const resetCustomerly = () => {
  try {
    const { customerly } = window as unknown as CustomerlyWindow
    if (!customerly) return
    customerly.logout()
  } catch (error) {
    console.log('Customerly error resetCustomerly')
    console.log(error)
  }
}
